/* tslint:disable */
/* eslint-disable */
/**
 * CMS API
 * The CMS API!
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { EntitlementType } from './entitlement-type';
import { LiveNewsModuleContentItem } from './live-news-module-content-item';
import { LiveNewsUIModuleContentTreatment } from './live-news-uimodule-content-treatment';
import { LocalizedFieldBody } from './localized-field-body';
import { TargetPlatform } from './target-platform';
import { UiModuleExperimentGroup } from './ui-module-experiment-group';

/**
 * 
 * @export
 * @interface LiveNewsUiModuleBody
 */
export interface LiveNewsUiModuleBody {
    /**
     * 
     * @type {string}
     * @memberof LiveNewsUiModuleBody
     */
    moduleId?: string;
    /**
     * 
     * @type {string}
     * @memberof LiveNewsUiModuleBody
     */
    slug?: string;
    /**
     * 
     * @type {string}
     * @memberof LiveNewsUiModuleBody
     */
    hash?: string;
    /**
     * 
     * @type {string}
     * @memberof LiveNewsUiModuleBody
     */
    moduleType: LiveNewsUiModuleBodyModuleTypeEnum;
    /**
     * 
     * @type {Array<TargetPlatform>}
     * @memberof LiveNewsUiModuleBody
     */
    targetPlatform?: Array<TargetPlatform>;
    /**
     * 
     * @type {LocalizedFieldBody}
     * @memberof LiveNewsUiModuleBody
     */
    caption?: LocalizedFieldBody;
    /**
     * 
     * @type {Array<EntitlementType>}
     * @memberof LiveNewsUiModuleBody
     */
    entitlements?: Array<EntitlementType>;
    /**
     * 
     * @type {Array<UiModuleExperimentGroup>}
     * @memberof LiveNewsUiModuleBody
     */
    experiments?: Array<UiModuleExperimentGroup> | null;
    /**
     * 
     * @type {LocalizedFieldBody}
     * @memberof LiveNewsUiModuleBody
     */
    title: LocalizedFieldBody;
    /**
     * 
     * @type {LiveNewsUIModuleContentTreatment}
     * @memberof LiveNewsUiModuleBody
     */
    contentTreatment: LiveNewsUIModuleContentTreatment;
    /**
     * 
     * @type {Array<LiveNewsModuleContentItem>}
     * @memberof LiveNewsUiModuleBody
     */
    liveNewsContents: Array<LiveNewsModuleContentItem>;
}

/**
    * @export
    * @enum {string}
    */
export enum LiveNewsUiModuleBodyModuleTypeEnum {
    LIVE_NEWS = 'LIVE_NEWS'
}



